import { Context } from '@nuxt/types';

export default async function(context: Context) {
  const { redirect, app } = context;

  // @ts-ignore For some reason it does not know about the token property https://github.com/nuxt-community/auth-module/issues/1338
  if (!app.$auth.strategy.token.get()) {
    redirect('/');
  }
}
